const shouldDisplayChart = ({data}) =>
  data.some((dataPoint) => !!dataPoint.data[0].y);

export default shouldDisplayChart;
